<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z"
      fill="#052E37"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 9C5 5.13 8.13 2 12 2C15.87 2 19 5.13 19 9H17C17 6.24 14.76 4 12 4C9.24 4 7 6.24 7 9C7 10.9938 8.42915 13.7267 10 16.103V19.555C7.93118 16.8414 5 12.3973 5 9Z"
      fill="#052E37"
    />
    <path
      d="M17 11C14.24 11 12 13.24 12 16C12 18.76 14.24 21 17 21C19.76 21 22 18.76 22 16C22 13.24 19.76 11 17 11ZM19.5 16.5H17.5V18.5H16.5V16.5H14.5V15.5H16.5V13.5H17.5V15.5H19.5V16.5Z"
      fill="#052E37"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ZamgPinAdd',
});
</script>
